import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/auth/AuthProvider";

export default function StaffLogin() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { staffLogin } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await staffLogin(email.trim().toLowerCase(), password);
      toast.success(t("auth.welcome"));
      if (["administrator", "super_administrator"].includes(user.role)) nav("/admin");
      else nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail?.error || t("auth.invalid_credentials"));
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="page-staff-login" className="max-w-md mx-auto px-6 py-16">
      <div className="tr-eyebrow">{t("auth.eyebrow")}</div>
      <h1 className="tr-section-title text-3xl lg:text-4xl mt-4">{t("auth.staff_title")}</h1>
      <p className="mt-3 text-[var(--tr-muted)]">{t("auth.staff_body")}</p>
      <form onSubmit={submit} className="tr-card p-6 mt-8 space-y-5" data-testid="staff-login-form">
        <label className="block">
          <span className="tr-label">{t("auth.email")}*</span>
          <input required type="email" data-testid="staff-login-email" className="tr-input" value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="block">
          <span className="tr-label">{t("auth.password")}*</span>
          <input required type="password" data-testid="staff-login-password" className="tr-input" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        <button type="submit" disabled={busy} data-testid="staff-login-submit" className="tr-pill-btn tr-btn-primary w-full disabled:opacity-60">
          {busy ? t("common.sending") : t("auth.sign_in")} <ArrowRight className="w-4 h-4" />
        </button>
        <div className="text-sm text-center">
          <Link to="/forgot-password" data-testid="staff-login-forgot" className="text-[var(--tr-deep-green)] underline">{t("auth.forgot_password")}</Link>
        </div>
      </form>
    </div>
  );
}
